// extracted by mini-css-extract-plugin
module.exports = {"root":"GuestCounter_root__2i5EP"};